import { module } from 'modujs';
import LazyLoad from "vanilla-lazyload";
import gsap, { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0);

        this.lazyLoad()
        this.isInView()
        this.update()
    }

    lazyLoad() {
        this.lazy = new LazyLoad({
            elements_selector: ".lazyload",
            thresholds: "0px 0px",
            callback_loaded: (el) => {
                el.classList.add('is-loaded')
            }
        })
    }

    isInView() {
        gsap.utils.toArray('[data-scroll]').forEach(el => {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    onEnter: () => el.classList.add('is-inview')
                }
            })
        });
    }

    scrollTo(args) {
        args.target.scrollTop;
    }

    update() {
        this.lazy.update()
    }

    destroy() {
        let STs = ScrollTrigger.getAll()

        STs.forEach(st => {
            if (st.scrollTrigger) st.scrollTrigger.kill();
            else st.kill();
        })
    }
}
